export default __webpack_public_path__ + "static/media/ico_clinic.f1bd45ca.svg";